import { combineReducers } from 'redux';
import { StateType } from 'typesafe-actions';

import dataExplorer from './data-explorer/reducer';
import entityHierarchies from './entity-hierarchies/reducer';
import organization from './organization/reducer';
import polls from './polls/reducer';
import resourceLists from './resource-lists/reducer';
import resources from './resources/reducer';
import router from './router/reducer';
import session from './session/reducer';
import * as sessionTypes from './session/types';
import userSettings from './user-settings/reducer';

const createRootReducer = () => (prevState: any, action: any) => {
    const reducer = combineReducers({
        router,
        session,
        organization,
        userSettings,
        dataExplorer,
        entityHierarchies,
        resourceLists,
        resources,
        polls,
    });

    switch (action.type) {
        // clean root state on sign out
        case sessionTypes.SESSION_SIGNED_OUT:
            return reducer({}, action);

        default:
            return reducer(prevState, action);
    }
};

export default createRootReducer;

export type RootState = StateType<ReturnType<typeof createRootReducer>>;
